import {Grow, GrowProps, IconButton, Snackbar, styled} from '@mui/material'
import React, {useEffect, useState} from 'react'
import CloseIcon from '@mui/icons-material/Close'
import {TransitionProps} from '@mui/material/transitions'
import * as component from './redux/componentRedux'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../setup'
import { useHistory } from 'react-router-dom'
import { RedirectPageNoti } from '../utils'
import { updateSellingNotification } from '../modules/auth/apis'

function GrowTransition(props: GrowProps) {
  return <Grow {...props} />
}

const SnackbarCustomCss = styled(Snackbar)(({theme}) => ({
  '& .MuiSnackbarContent-root': {
    color: '#000',
    backgroundColor: '#fff',
    minWidth: '300px',
    padding: '20px 16px',
    fontSize: '1.1rem',
  },
}))

export const SnackbarCustom = () => {
  //   const [open, setOpen] = useState(false)
  const [state, setState] = useState<{
    open: boolean
    Transition: React.ComponentType<
      TransitionProps & {
        children: React.ReactElement<any, any>
      }
    >
  }>({
    open: false,
    Transition: GrowTransition,
  })
  const [message, setMessage] = useState('')
  const reduxUserState = useSelector((state: RootState) => state.component)
  const snackbarState = reduxUserState.snackbar
  const dispatch = useDispatch()
  const history = useHistory()
  
  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    setState({
      ...state,
      open: false,
    })
  }

  const handleClickSnackbar = async () => {
    // await updateSellingNotification(id)
    RedirectPageNoti(snackbarState.contractId, snackbarState.productCode, history)
    setState({
      ...state,
      open: false,
    })
  }

  const action = (
    <React.Fragment>
      <IconButton size='small' aria-label='close' color='primary' onClick={handleClose}>
        <CloseIcon fontSize='small' />
      </IconButton>
    </React.Fragment>
  )

  useEffect(() => {
    if (snackbarState && snackbarState.show) {
      setState({
        ...state,
        open: true,
      })
      setMessage(snackbarState.message)
    }
  }, [snackbarState])

  useEffect(() => {
    if (!state.open) {
      dispatch(component.actions.showSnackbar({show: false, message: '', contractId: '', productCode: ''}))
    }
  }, [state.open])

  return (
    <div onClick={handleClickSnackbar} style={{cursor: 'pointer'}}>
      <SnackbarCustomCss
        open={state.open}
        TransitionComponent={state.Transition}
        autoHideDuration={4000}
        onClose={handleClose}
        message={message}
        key={state.Transition.displayName}
        action={action}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        style={{backgroundColor: '#fff'}}
      />
    </div>
  )
}
